<template>
<b-navbar  toggleable="md" type="dark" variant="primary" style="background-color: #17a2b8!important; padding-left: 80px; width:100%; position:fixed; padding-bottom:0px; padding-top:0px; z-index: 1000 !important; top:0px;" sticky>
    <b-navbar-brand href="#">
      <img src="../../assets/logo_small.png" class="d-inline-block align-top mt-1" style="height:40px">
      Я-ЭКСПЕРТ
    </b-navbar-brand>
<b-navbar-toggle target="nav_collapse" ></b-navbar-toggle>
  <b-collapse is-nav id="nav_collapse">
    <!-- Right aligned nav items -->
    <b-navbar-nav class="ml-auto">
      <li class="nav-item"><router-link class="nav-link" to="/">{{ $t('navbar.main') }}</router-link></li>
      <li v-if="!$auth.check()" class="nav-item"><router-link class="nav-link" to="/login">{{ $t('navbar.login') }}</router-link></li>
      <li v-if="$auth.check()" class="nav-item"> <a href="#" class="nav-link" v-on:click.prevent="logout()">{{ $t('navbar.logout') }}</a></li>

    </b-navbar-nav>

  </b-collapse>

</b-navbar>

</template>

<script>
    

    export default {
      name: 'navbar',
      methods: {
          changeLang(lang){
            this.$i18n.locale = lang
            this.$http.defaults.headers.common['lang'] = lang
            this.$moment.locale(lang)
          },
        logout () {
          this.$auth.logout({
            makeRequest: true,
            success () {
              console.log('success ' + this.context)
            },
            error () {
              console.log('error ' + this.context)
            }
          })
        },

        unimpersonate () {
          this.$auth.unimpersonate({
            success () {
              console.log('success ' + this.context)
            },
            error () {
              console.log('error ' + this.context)
            }
          })
        }
      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .nav-item {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
</style>
